// extracted by mini-css-extract-plugin
export default {"dashboard-wrapper":"dashboard-wrapper_RtfFj","filter-bar":"filter-bar_SgM2c"};